const navMixin = {

    methods: {
        navToSignin(data = null) {
            let url = window.location.origin + '/sign-in'
            if (data != null) {
                url += '?'
                Object.keys(data).forEach(function (key, index) {
                    if(index != 0) url += '&'
                    url += key + '=' + encodeURIComponent(data[key])
                });
            }
            window.open(url, "_self")
        },
        navToLinkQuestion() {
            let url = window.location.origin + '/own-business'
            window.open(url, "_self")
        },
    }
};

export default navMixin;
